import React from "react";
import Select from "react-select";
import { useAppSelector } from "../../_App/Redux/hooks";
import { ListOrganisations } from "../../_App/Redux/Slices/organisations/organisationSlice";

export default function FiltreRapportClient({
  t,
  filtre,
  setFiltre,
  organisationFilter,
  setOrganisationFilter,
  handleSearch,
  handleReset,
}: any) {
  const listOrganisations = useAppSelector(ListOrganisations);

  const OrganisationOptions = listOrganisations?.map((option: any) => ({
    value: option._id,
    label: option.nom,
  }));

  const handleSelectChangeOrganisation = (selectedOption: any) => {
    const organisation = (selectedOption || []).map((item: any) => item.value);
    setOrganisationFilter(organisation);
  };

  return (
    <div className="row bg-white" style={{ padding: "20px" }}>
      <div className="col-2">
        <div className="form-group">
          <label htmlFor="magasin">
            {" "}
            <span style={{ color: "red" }}></span>
            {t("Organisation")}
          </label>
          <Select
            isMulti
            options={OrganisationOptions}
            isSearchable={true}
            onChange={handleSelectChangeOrganisation}
            value={organisationFilter?.map((item: any) =>
              OrganisationOptions?.find((org: any) => org.value === item)
            )}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </div>
      </div>
      <div className="col-3">
        <label>{t("Client (nom, mobile, code à barre)")}</label>
        <input
          type="text"
          value={filtre.searchterm}
          onChange={(e) =>
            setFiltre({ ...filtre, searchterm: e.target.value })
          }
          className="form-control "
        />
      </div>
      <div className="col-3">
        <label>{t("Date Debut")}</label>
        <input
          type="date"
          value={filtre.dateDebut}
          onChange={(e) => setFiltre({ ...filtre, dateDebut: e.target.value })}
          className="form-control "
        />
      </div>
      <div className="col-3">
        <label>{t("Date Fin")}</label>
        <input
          type="date"
          value={filtre.dateFin}
          onChange={(e) => setFiltre({ ...filtre, dateFin: e.target.value })}
          className="form-control "
        />
      </div>
      <div className="col-1 mt-3 fs-25 " onClick={handleSearch}>
        {" "}
        <i className="fas fa-search" title={t("Rechercher") as string}></i>
      </div>
      <div className="col-1 mt-3 fs-25 " onClick={handleReset}>
        {" "}
        <i className="fas fa-undo" title={t("Réinitialiser") as string}></i>
      </div>
    </div>
  );
}
